module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 11\" class=\"icon-play\"><path fill-rule=\"evenodd\" d=\"m9.283 6.47l-7.564 4.254c-.949.534-1.719.266-1.719-.576v-9.292c0-.852.756-1.117 1.719-.576l7.564 4.254c.949.534.963 1.392 0 1.934\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/app/views/shared/icons/_icon_play.svg
// module id = ../../views/shared/icons/_icon_play.svg
// module chunks = commit_pipelines environments environments_folder pipelines